export default __webpack_public_path__ + "static/sol-c077322fca52f865e03d6f593096d4f2.webp";